var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-header-top-container" }, [
          _c("div", { staticClass: "page-name" }, [
            _vm._v(
              "Draggable " +
                _vm._s(_vm.formatString(_vm.sliderType)) +
                " Slider Image List"
            )
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary pull-right",
              attrs: { type: "submit" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.addSlider.apply(null, arguments)
                }
              }
            },
            [_vm._v("Add")]
          ),
          _vm._v(" "),
          _vm.sliderType == "benefit" || _vm.sliderType == "401k"
            ? _c(
                "div",
                {
                  staticClass:
                    "col-xs-12 col-sm-12 col-md-3 col-lg-3 pull-right"
                },
                [
                  _c("v-select", {
                    attrs: {
                      name: "locationType",
                      id: "locationType",
                      label: "text",
                      clearable: false,
                      searchable: false,
                      filterable: false,
                      options: _vm.locationTypeArr,
                      placeholder: "Select Location Type"
                    },
                    model: {
                      value: _vm.locationType,
                      callback: function($$v) {
                        _vm.locationType = $$v
                      },
                      expression: "locationType"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c(
            "div",
            { staticClass: "cards-container" },
            [
              _c(
                "draggable",
                {
                  staticClass: "drag-view",
                  on: {
                    change: function($event) {
                      return _vm.changePosition()
                    }
                  },
                  model: {
                    value: _vm.imageList,
                    callback: function($$v) {
                      _vm.imageList = $$v
                    },
                    expression: "imageList"
                  }
                },
                [
                  _vm._l(_vm.imageList, function(text, index) {
                    return [
                      _c("div", { staticClass: "col-4 mb-5" }, [
                        _c("div", { staticClass: "cards-block" }, [
                          _c("div", { staticClass: "card" }, [
                            _c("img", {
                              key: index,
                              staticClass: "card-img-top",
                              attrs: { src: text.image }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "card-body" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "ml-2 mr-2 btn btn-danger pull-right",
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.deleteSliderImage(text.id)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-trash",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "router-link",
                                  {
                                    staticClass: " btn btn-primary pull-right",
                                    attrs: {
                                      title:
                                        "Edit " +
                                        _vm.formatString(_vm.sliderType) +
                                        " Slider",
                                      to: {
                                        name: "UpdateSlider",
                                        params: {
                                          id: text.id,
                                          type: _vm.sliderType
                                        }
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-pencil",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ])
                      ])
                    ]
                  })
                ],
                2
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6290f192", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6290f192","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/slider/ListSlider.vue
// module id = null
// module chunks = 